import React from 'react';
import { Text } from '@react-pdf/renderer';
import dayjs from 'dayjs';
import defaultStyles from '../../components/print-pdf/defaultStyles';

export const PrintDate = props => {
    const style = props.isForPDF ? defaultStyles.title_header : defaultStyles.print_date;

    return (
        <Text style={style}>
                Report Time: {dayjs().format('MM/DD/YYYY HH:mm:ss A')}
        </Text>
    );
};
